import React from 'react';
export function IntroContent() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-415">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-416">
        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border mb-12" style={{
        borderColor: '#ede9e0'
      }} data-id="element-417">
          <h2 className="text-2xl font-bold uppercase mb-4" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-418">
            .22 Rim Fire Fun Shoots
          </h2>
          <p className="text-base text-gray-800 mb-4 leading-relaxed" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-419">
            Come out and join us for .22 rim fire fun shoots. Shoot for yourself
            or bring a friend for some friendly competition. A great event for
            the whole family and a great introduction to shooting sports.
          </p>
          <p className="text-base text-gray-800 leading-relaxed" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-420">
            FLSC Bowling Pin shoots were created to provide a fun event where
            people can learn safe gun handling, improve their marksmanship
            skills and learn how to better handle their gun in a fun and
            mentoring environment with other shooters.
          </p>
        </div>
      </div>
    </div>;
}